const { addActions } = require('js-data-http')

let mapper_options = {
  endpoint: 'share_setting_copy_options',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      share_setting: {
        foreignKey: 'share_setting_id',
        localField: 'share_setting'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('share_setting_copy_option', mapper_options)
}
